import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Landing from "./pages/Landing";
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';


function App() {
    return (
        <div dir="rtl">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing/>}/>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
